import { cn } from '@invent/wl-ui-kit-next';
import * as React from 'react';

/**
 * A table's frame, scrolling sideways on its own. Its width is **contained** — it takes no size
 * from the table — because the screens that use it nest tables inside their sections, and a
 * scroll container inside a grid item still hands the table's width up to the page's grid: on a
 * phone the SEC ADV firm card's ten custodian columns widened every section past the screen, and
 * the person hub's number tables would do the same. A table directly in a page's grid shrinks by
 * itself and needs none of this.
 */
export function TableFrame({
  className,
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        'overflow-x-auto rounded-md border border-border [contain:inline-size]',
        className
      )}
    >
      {children}
    </div>
  );
}
